export const CREATE_ORGANIZATIONCUSTOMFIELD = 'CREATE_ORGANIZATIONCUSTOMFIELD';
export const DELETE_ORGANIZATIONCUSTOMFIELD = 'DELETE_ORGANIZATIONCUSTOMFIELD';
export const SAVE_ORGANIZATIONCUSTOMFIELDS = 'SAVE_ORGANIZATIONCUSTOMFIELDS';
export const UPDATE_ORGANIZATIONCUSTOMFIELD = 'UPDATE_ORGANIZATIONCUSTOMFIELD';
export const UPDATE_ORGANIZATIONCUSTOMFIELDS_LIST = 'UPDATE_ORGANIZATIONCUSTOMFIELDS_LIST';
export const UPDATE_ORGANIZATIONCUSTOMFIELDS_TOTAL_COUNT = 'UPDATE_ORGANIZATIONCUSTOMFIELDS_TOTAL_COUNT';
